import * as CL from '@design-system/component-library';
import { t } from '../../common/i18n';

import './PriceChangeInfo.scss';

export const PriceChangeInfo = () => (
  <div className="of-order-summary-price-change-info">
    <span className="of-order-summary-price-change-info--icon">
      <CL.Icon icon="information" type="regular" color="black" />
    </span>
    <div>
      {t.N81L(
        'We are updating the prices of services and subscriptions for corporate customers. The list prices will increase by 8.9% on June 1, 2025.'
      )}
    </div>
  </div>
);
